/**
 * getSessionHeaders
 *
 * Composes `getSessionCollectionName()`, `getSessionAreaName()`, and
 * `resolveAreaId()` into a `Record<string, string>` of HTTP session headers.
 *
 * This is a domain function created and tested but **not yet integrated**
 * into `ccApi.prepareHeaders` or `buildSessionHeaders()`. The existing
 * header injection mechanism remains unchanged until the investigation
 * phase (BS-1169) is complete.
 *
 * @param areas - The full list of areas from state.
 * @param collections - The full list of collections from state.
 * @returns A record containing the session HTTP headers that have values.
 *
 * @see src/platform-services/session/getSessionCollectionName.ts
 * @see src/platform-services/session/getSessionAreaName.ts
 * @see src/platform-services/session/resolveAreaId.ts
 * @see src/client/utils.ts — buildSessionHeaders (legacy, unchanged)
 */
import { getSessionAreaName } from './getSessionAreaName';
import { getSessionCollectionName } from './getSessionCollectionName';
import { resolveAreaId } from './resolveAreaId';
export const SESSION_HEADER_AREA_NAME = 'X-Groupby-Area-Name';
export const SESSION_HEADER_AREA_ID = 'X-Groupby-Area-Id';
export const SESSION_HEADER_COLLECTION_NAME = 'X-Groupby-Collection-Name';
export const getSessionHeaders = (areas, collections) => {
    const headers = {};
    const areaName = getSessionAreaName();
    const collectionName = getSessionCollectionName();
    const areaId = resolveAreaId(collectionName, areaName, areas, collections);
    if (areaName)
        headers[SESSION_HEADER_AREA_NAME] = areaName;
    if (areaId)
        headers[SESSION_HEADER_AREA_ID] = String(areaId);
    if (collectionName)
        headers[SESSION_HEADER_COLLECTION_NAME] = collectionName;
    return headers;
};
